export default "__VITE_ASSET__BcDlG7UK__"